<div class="confirm-action-dialog-icon">
  <div (click)="onClickIcon($event)">
    <span pTooltip="{{tooltip | translate}}" tooltipPosition="{{tooltipPosition}}">
      <i class="{{icon}} pointer"></i>
    </span>
  </div>
  <ng-container *ngIf="displayDialog">
    <si-confirm-action-dialog [(displayDialog)]="displayDialog"
                              [iconClass]="iconDialog"
                              [headerTitleDialog]="headerTitleDialog"
                              [titleDialog]="titleDialog"
                              [subtitleDialog]="subtitleDialog"
                              (updateChange)="onConfirmActionDialog()"
    ></si-confirm-action-dialog>
  </ng-container>
</div>
